"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPlaceDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Venue_dto_1 = require("./Venue.dto");
const VenueListStats_dto_1 = require("./VenueListStats.dto");
class MyPlaceDto {}
exports.MyPlaceDto = MyPlaceDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: () => Venue_dto_1.VenueDto
}), __metadata("design:type", Venue_dto_1.VenueDto)], MyPlaceDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], MyPlaceDto.prototype, "pinnedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => VenueListStats_dto_1.VenueListStatsDto,
  required: false,
  description: 'Present in the My Places list.'
}), __metadata("design:type", VenueListStats_dto_1.VenueListStatsDto)], MyPlaceDto.prototype, "stats", void 0);
//# sourceMappingURL=MyPlace.dto.js.map